/**
 * Shared pure display utilities for PSS dashboard components.
 */

/**
 * Normalize a PSS sprite ID for use in templates.
 * Returns '' for missing/zero IDs (so *ngIf cleanly hides), otherwise the id itself.
 *
 * Note: this used to return a direct image URL (`/pss/.../DownloadSprite?spriteId=N`),
 * but PSS's DownloadSprite endpoint is broken server-side. Sprites are now rendered
 * via the <pss-sprite> component, which crops the relevant region of an S3
 * spritesheet using the SpriteId→ImageFileId map from FileService/ListSprites.
 */
export function spriteIdOrEmpty(spriteId: string | number | null | undefined): string {
  if (spriteId == null) return '';
  const s = String(spriteId);
  if (!s || s === '0') return '';
  return s;
}

/** Human-readable label for equipment slot subtypes. */
export function equipSlotLabel(subtype: string): string {
  const m: Record<string, string> = {
    EquipmentBody:      'Body',
    EquipmentHead:      'Head',
    EquipmentLeg:       'Leg',
    EquipmentWeapon:    'Weapon',
    EquipmentPet:       'Pet',
    EquipmentAccessory: 'Accessory',
    EquipmentHand:      'Hand',
    EquipmentSticker:   'Sticker',
  };
  return m[subtype] ?? subtype.replace('Equipment', '');
}

export const RARITY_ORDER = [
  'Common',
  'Elite',
  'Unique',
  'Epic',
  'Hero',
  'Special',
  'Legendary',
] as const;

const RARITY_RANK_MAP: Record<string, number> = RARITY_ORDER.reduce((acc, rarity, idx) => {
  acc[rarity.toLowerCase()] = idx;
  return acc;
}, {} as Record<string, number>);

export function rarityRank(rarity: string): number {
  return RARITY_RANK_MAP[rarity.trim().toLowerCase()] ?? -1;
}
